export const STATIC_CLASSES = Object.freeze({
	root: 'testimonial2',
	content: 'testimonial2-content',
})
